export default (dateString) => {
  if (Number.isNaN(Date.parse(dateString))) return dateString;
  return new Date(dateString);
};
